import DashboardTable from './DashboardTable';

export default DashboardTable;
